<div class="table-container">
  @if (itemList) {
    <table mat-table multiTemplateDataRows #table [dataSource]="itemList">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let row">{{ row.dataModel.name }}</td>
      </ng-container>
      <ng-container matColumnDef="actions" stickyEnd>
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <icon-action-button-list [data]="row" class="action-icons" [actionItems]="row.processActions"
          (onInvokeAction)="doIconButtonAction($event)"></icon-action-button-list>
        </td>
      </ng-container>
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
          <div class="expanded-detail" [@detailExpand]="row.expanded ? 'expanded' : 'collapsed'">
            <div class="expanded-detail-content">
              <activity-file-preview [uniqueIdentifier]="row?.dataModel.uniqueIdentifier" [visible]="row.expanded"></activity-file-preview>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="selectRow(row); toggleExpanded(row)"
        class="table-data-row"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    </table>
  }
</div>